import JSZip from "jszip";

export const parseNPFile = async (zipFile: File, selectedScenario: string | undefined) => {
    const inputZip = new JSZip();
    const topLvlZip = await inputZip.loadAsync(zipFile);
    const topLvlFiles = Object.keys(topLvlZip.files);
    let file = topLvlFiles.find(f => f.includes("F120") && f.endsWith(".xml"));
    if (!file) file = topLvlFiles.find(f => f.includes("F101") && f.endsWith(".xml"));
    if (!file) file = topLvlFiles.find(f => f.includes("F110") && f.endsWith(".xml"));
    if (!file) file = topLvlFiles.find(f => f.includes("-614-") && f.endsWith(".xml"));
    if (!file) file = topLvlFiles.find(f => f.includes("-632-") && f.endsWith(".xml"));
    //LTCC file will be found by scenario name eg. "S01"
    if (!file && selectedScenario) {
        let f110file = topLvlFiles.find(f => f.includes("110") && f.endsWith(".zip"));
        const loaded110 = await topLvlZip.file(f110file!)!.async("blob");
        const loadedSubZip = await inputZip.loadAsync(loaded110);
        const downLevelFiles = Object.keys(loadedSubZip.files);
        if (!file) {
            file = downLevelFiles.find(f => f.includes("110") && f.includes(selectedScenario) && f.endsWith(".xml"));
        }
    }
    const str = await topLvlZip.file(file!)!.async("string");
    const parser = new DOMParser();
    const xml = parser.parseFromString(str, "text/xml");
    const json: any = xml2Json(xml);
    return json.publicationDocument;
};

const xml2Json = (xml: any) => {
    let json: any = {};
    if (xml.nodeType === 1) {
        if (xml.attributes.length > 0) {
            json["attributes"] = {};
            for (let j = 0; j < xml.attributes.length; j++) {
                const attribute = xml.attributes.item(j);
                json["attributes"][str2CamelCase(attribute.nodeName)] = attribute.nodeValue;
            }
        }
    } else if (xml.nodeType === 3) json = xml.nodeValue!;
    if (xml.hasChildNodes()) {
        for (let i = 0; i < xml.childNodes.length; i++) {
            const item = xml.childNodes.item(i);
            const nodeName = str2CamelCase(item.nodeName);
            if (typeof json[nodeName] === "undefined") json[nodeName] = xml2Json(item);
            else {
                if (typeof json[nodeName].push === "undefined") {
                    const old = json[nodeName];
                    json[nodeName] = [];
                    json[nodeName].push(old);
                }
                json[nodeName].push(xml2Json(item));
            }
        }
    }
    return json;
};

const str2CamelCase = (str: string) => {
    return str.charAt(0).toLowerCase() + str.slice(1);
};
